import classnames from "classnames";
import withDismissible from "../WithDismissible";
import NotificationsOptInBanner from "../NotificationsOptInBanner";
import styles from "./index.css";

const className = classnames(styles.notificationsOptInBanner, styles.show);

export default withDismissible({
  component: NotificationsOptInBanner,
  className,
  shouldRenderKey: "showNotificationsOptInBanner"
});
